export default {
  cards: {
    table: {
      kegiatanDakwah: {
        queryName: "kegiatan_dakwah",
        content: {
          title: "Kegiatan Dakwah",
          showTitle: true,
          showSubtitle: false,
          showIcon: false,
          info: "#### Menunjukan seluruh data kegiatan dakwah",
          showInfo: true,
          showSaveAsImage: false,
          showTable: false,
          showDownloadCSVTable: true,
          showDownloadExcelTable: true,
        },
        options: {
          columns: [
            {
              title: "Jenis Kegiatan",
              dataIndex: "kegiatan_dakwah",
              sorter: (a, b) =>
                a.kegiatan_dakwah.localeCompare(b.kegiatan_dakwah),
            },
            {
              title: "Jumlah Pesantren",
              dataIndex: "count",
              sorter: (a, b) => a.count - b.count,
            },
          ],
          rowClassName: (record, index) => {
            return index % 2 === 0 ? "table-row-lighter" : "table-row-darker";
          },
          dataSource: [],
        },
        state: {},
      },
    },
  },
};
